module.exports = __webpack_public_path__ + "img/phone-call.45300400.svg";